import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)
import Privacy from './privacy.vue'
import 'common/script/getRem.js'
import 'common/stylus/index.styl'
import Config from 'common/script/config.js'

Vue.http.options.emulateJSON = true
Vue.http.interceptors.push((request, next) => {
  // 请求发送前的处理逻辑
  Vue.http.headers.common[Config.HTTP_HEADER_KEY.APP_KEY] = Config.APP_KEY
  // Vue.http.headers.common[Config.HTTP_HEADER_KEY.UDID] = navigator.appVersion
  Vue.http.headers.common[Config.HTTP_HEADER_KEY.CHANNEL] = Config.getChannel()

  next((response) => {
    // ...
    // 请求发送后的处理逻辑
    // ...
    // 根据请求的状态，response参数会返回给successCallback或errorCallback
    return response
  })
})
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  },
  update: function (el, binding) {
    document.title = el.dataset.title
  }
})

/* eslint-disable no-new */
new Vue({
	render: h => h(Privacy)
}).$mount('#privacy')



// WEBPACK FOOTER //
// ./src/module/privacy/privacy.js